import { ComponentChildren, h, RefObject } from 'preact';
import { observer } from 'mobx-react-lite';
import { useEffect, useRef } from 'preact/hooks';
import isMobileRender from 'src/common/helpers/isMobileRender';
import cn from 'classnames';
import ResizeObserver from 'resize-observer-polyfill';

const applyCustomStyles = async (url: string) => {
    try {
        const id = 'customStyles';
        if (!document.getElementById(id)) {
            const head =
                document.head || document.getElementsByTagName('head')[0];
            const link = document.createElement('link');

            link.id = id;
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = decodeURIComponent(url);
            link.media = 'all';
            head.appendChild(link);
        }
    } catch (error) {
        console.log('Error loading external styles');
    }
};

const setTheme = (theme: string | null) => {
    if (theme && theme !== 'default') {
        const filePath = `/common/themes/${theme}/assets/index.css`;
        applyCustomStyles(filePath);
    }
};

function RenderWrapper({ children }: { children: ComponentChildren }) {
    const renderRef = useRef<HTMLDivElement>(null);
    const { search } = window.location;
    const params = new URLSearchParams(search);
    const theme = params.get('theme');

    const resizeOb = new ResizeObserver(function (entries) {
        const target = entries[0].target;
        const height = target.clientHeight;
        window.parent.postMessage(
            JSON.stringify({ type: 'iframeHeight', height }),
            '*',
        );
    });

    useEffect(() => {
        setTheme(theme);
        if (renderRef.current) {
            resizeOb.observe(renderRef.current);
        }
        return () => {
            if (renderRef.current) {
                resizeOb.unobserve(renderRef.current);
            }
        };
    }, []);

    const mobile = isMobileRender();

    return (
        <div
            className={cn('game-render', {
                _mobile: mobile,
            })}
            ref={renderRef}
        >
            {children}
        </div>
    );
}

export default observer(RenderWrapper);
